/* eslint-disable react/no-unused-state */
import React from 'react';
import { Form } from 'react-form';
import { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import moment from 'moment';
import { includes } from 'lodash';
import { requiredEmail, required } from '../../../utils/validation';
import { Input, Select, Location, PhoneNumber } from '../../Form';
import { daysPerMonth, monthOptions } from '../../../utils/constants';
import { SupportLink } from '../../Links';
import { getPlayerGradYearOptions, getClassYearOptions } from '../../../utils';

const _ = { includes };

class ClubAddMembersForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            days: daysPerMonth[0],
        };
        this.handleLocationChange = this.handleLocationChange.bind(this);
        this.handleLocationSelect = this.handleLocationSelect.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
    }

    handleLocationChange(location) {
        this.setState({
            location,
            geocodeResults: null,
        });
    }

    handleLocationSelect(location) {
        this.setState({
            location,
        });

        geocodeByAddress(location)
            .then(results => getLatLng(results[0]))
            .then(({ lat, lng }) => {
                console.log('Geocode Success', { lat, lng });
                this.setState({
                    geocodeResults: { lat, lng },
                });
            })
            .catch(error => {
                console.log('Geocode Error', error);
                this.setState({
                    geocodeResults: null, // TODO: handle error properly
                });
            });
    }

    handleDateChange(val) {
        const monthVal = val || 1;
        this.setState({
            days: daysPerMonth[monthVal - 1],
        });
    }

    render() {
        const locationInputProps = {
            // value: this.state.location,
            placeholder: 'Location (zip or city)',
            name: 'location',
        };
        let years = Array.from(new Array(moment().year() - 1899), (x, i) => i + 1900);
        years = years.sort((a, b) => b - a);
        const dayValues = Array.from(new Array(this.state.days), (x, i) => i + 1);

        const {
            showMemberTypeSelect,
            showPowerInput,
            checkGate,
            featureGates,
        } = this.props;

        // Check feature flag once for reuse in render
        const isRostersRolloutEnabled = checkGate && featureGates ? checkGate(featureGates.ROSTERS_ROLLOUT) : false;
        const gradYearOptions = isRostersRolloutEnabled ? getClassYearOptions() : getPlayerGradYearOptions(true);
        const fieldName = isRostersRolloutEnabled ? 'classYearId' : 'gradYear';
        const yearLabel = isRostersRolloutEnabled ? 'Class Year' : 'Graduation Year';
        const yearEmptyOption = isRostersRolloutEnabled ? 'Please select a class year' : 'Please select a graduation year';

        const defaultValues = {
            sendEmailNotification: true,
            isPhysicalMember: showMemberTypeSelect ? null : false,
            isPower: showPowerInput ? null : false,
        };

        const onKeyPress = (event) => {
            if (event.key === 'Enter' && event.target.type !== 'submit' && event.target.type !== 'button' && event.target.id !== 'about') {
                event.preventDefault();
            }
        };
        return (
            <Form getApi={this.props.getFormApi} onSubmit={values => this.props.handleSubmit(values)} defaultValues={defaultValues} id="addMembersForm">
                {({ submitForm }) => {
                    return (
                        <form onSubmit={submitForm} id="addMembersForm" onKeyPress={onKeyPress}>
                            <React.Fragment>
                                {this.props.showMemberInfo && this.props.isHighSchool && (
                                    <div className={`container bg-transparent`}>
                                        <div className={`row`}>
                                            <div className={`col-md-2`}>
                                                <h5 className={`text-uppercase`}>Player Info</h5>
                                            </div>
                                            <div className="col-md-8 mb8 mr-auto text-small text-center">
                                                Insert player email to invite them to join your team page on UTR Sports
                                            </div>
                                            <div className={`offset-md-3 col-md-6 mt56`}>
                                                {this.props.showMemberInfo && (
                                                    <React.Fragment>
                                                        <div className="form-group form-group-xl">
                                                            <Input
                                                                label="Email"
                                                                key={`email`}
                                                                id={`email`}
                                                                field={`email`}
                                                                type="text"
                                                                placeholder="name@example.com"
                                                                validate={requiredEmail}
                                                                disableProfanityCheck={true}
                                                            />
                                                        </div>
                                                    </React.Fragment>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {(this.props.showMemberInfo && !this.props.showGradYear) && (
                                    <div className={`container bg-transparent`}>
                                        <div className={`row`}>
                                            <div className={`col-md-3`}>
                                                <h5 className={`text-uppercase`}>Player Info</h5>
                                            </div>
                                            <div className={`col-md-6 mt56`}>
                                                {this.props.showMemberInfo && (
                                                    <React.Fragment>
                                                        <div className="form-group form-group-xl">
                                                            <Input
                                                                label="Email"
                                                                key={`email`}
                                                                id={`email`}
                                                                field={`email`}
                                                                type="text"
                                                                placeholder="name@example.com"
                                                                validate={requiredEmail}
                                                                disableProfanityCheck={true}
                                                            />
                                                        </div>
                                                        <div className={`row`}>
                                                            <div className={`col-md-6`}>
                                                                <div className="form-group form-group-xl">
                                                                    <Input
                                                                        label="First Name"
                                                                        key={`firstname`}
                                                                        id={`firstname`}
                                                                        field={`firstName`}
                                                                        type="text"
                                                                        placeholder="Enter First Name"
                                                                        validate={required}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className={`col-md-6`}>
                                                                <div className="form-group form-group-xl">
                                                                    <Input
                                                                        label="Last Name"
                                                                        key={`lastname`}
                                                                        id={`lastname`}
                                                                        field={`lastName`}
                                                                        type="text"
                                                                        placeholder="Enter Last Name"
                                                                        validate={required}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className={`row`}>
                                                            <div className={`col-md-6`}>
                                                                <div className="form-group form-group-xl">
                                                                    <Select
                                                                        label={`Gender`}
                                                                        emptyOption={`Select Gender`}
                                                                        id={`gender`}
                                                                        field={'gender'}
                                                                        options={[{ label: 'Male', id: 'M' }, { label: 'Female', id: 'F' }]}
                                                                        validate={required}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className={`col-md-6`}>
                                                                <div className="form-group form-group-xl">
                                                                    <Location
                                                                        label="Location/Residence"
                                                                        id="location"
                                                                        field={'location'}
                                                                        inputProps={locationInputProps}
                                                                        handleChange={this.handleLocationChange}
                                                                        handleSelect={this.handleLocationSelect}
                                                                        options={{ types: ['(regions)'] }}
                                                                        useDynamicOption={false}
                                                                        showMap={false}
                                                                        placeholder="Enter City, State"
                                                                        validate={required}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="form-group form-group-xl">
                                                            <label>Birthdate (optional)</label>
                                                            <div className="row">
                                                                <div className="col-md-5 col-5">
                                                                    <Select
                                                                        id="month"
                                                                        field="month"
                                                                        options={monthOptions}
                                                                        emptyOption="Month"
                                                                        hiddenLabel={true}
                                                                        onChange={(val) => this.handleDateChange(val)}
                                                                    />
                                                                </div>
                                                                <div className="col-md-3 col-3">
                                                                    <Select
                                                                        id="day"
                                                                        field="day"
                                                                        options={dayValues}
                                                                        optionsAsPrimitiveArray={true}
                                                                        hiddenLabel={true}
                                                                        emptyOption="Day"
                                                                    />
                                                                </div>
                                                                <div className="col-md-4 col-4">
                                                                    <Select
                                                                        id="year"
                                                                        field="year"
                                                                        options={years}
                                                                        isArray={true}
                                                                        hiddenLabel={true}
                                                                        optionsAsPrimitiveArray={true}
                                                                        emptyOption="Year"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="form-group form-group-xl">
                                                            <PhoneNumber
                                                                label="Phone Number (optional)"
                                                                description=""
                                                                id="phone"
                                                                field="phone"
                                                                placeholder="(212) 555-5555"
                                                            />
                                                        </div>
                                                    </React.Fragment>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {this.props.showGradYear && !this.props.showMemberInfo && (
                                    <React.Fragment>
                                        <div className={`container bg-transparent`}>
                                            <div className={`row`}>
                                                <div className={`offset-md-3 col-md-6`}>
                                                    <div className="form-group form-group-xl">
                                                        <Select
                                                            key={`player-grad-year`}
                                                            id={`player-grad-year`}
                                                            label={yearLabel}
                                                            field={fieldName}
                                                            emptyOption={yearEmptyOption}
                                                            options={gradYearOptions}
                                                            validate={required}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </React.Fragment>
                                )}
                                {!this.props.showGradYear && (
                                    <div className={`container bg-transparent`}>
                                        <div className={`row`}>
                                            <div className={`col-md-3`}>
                                                <h5 className={`text-uppercase`}>Club Membership</h5>
                                            </div>
                                            <div className={`col-md-6 mt56`}>
                                                <div className="form-group form-group-xl">
                                                    <Select
                                                        label={`Member Role`}
                                                        emptyOption={`Select Member Role`}
                                                        id={`memberRole`}
                                                        field={'role'}
                                                        options={[
                                                            { label: 'Member', id: 'member' },
                                                            { label: 'Provider', id: 'admin' },
                                                            { label: 'Head Provider', id: 'owner' },
                                                        ]}
                                                        validate={required}
                                                    />
                                                </div>
                                                <div className={`row`}>
                                                    {showMemberTypeSelect && (
                                                        <div className={this.props.showPowerInput ? `col-md-6` : `col-md-12`}>
                                                            <div className="form-group form-group-xl">
                                                                <Select
                                                                    label={`Member Type`}
                                                                    emptyOption={`Select Member Type`}
                                                                    id={`memberType`}
                                                                    field={'isPhysicalMember'}
                                                                    options={[{ label: 'Physical', id: 'true' }, { label: 'Digital', id: 'false' }]}
                                                                    validate={required}
                                                                />
                                                            </div>
                                                        </div>
                                                    )}
                                                    {showPowerInput && (
                                                        <div className={`col-md-6`}>
                                                            <div className="form-group form-group-xl">
                                                                <Select
                                                                    label={`Power Subscription`}
                                                                    emptyOption={`Select Power Status`}
                                                                    id={`power`}
                                                                    field={'isPower'}
                                                                    options={[{ label: 'Yes', id: 'true' }, { label: 'No', id: 'false' }]}
                                                                    validate={required}
                                                                />
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </React.Fragment>

                            <div className={`mb10 ${this.props.validationMessage && 'is-invalid'}`}>
                                {this.props.validationMessage && (
                                    _.includes(this.props.validationMessage, 'already registered') ? (
                                        <div className="invalid-feedback">
                                            {this.props.validationMessage}
                                            You can use a different email to create an account for this player or please contact our <SupportLink target="_blank">support team.</SupportLink>
                                        </div>
                                    ) : (
                                        <div className="invalid-feedback">
                                            {this.props.validationMessage}
                                        </div>
                                    )
                                )}
                            </div>
                            <div className={`container bg-transparent`}>
                                <div className={`row`}>
                                    <div className={` offset-md-3 col-md-6`}>
                                        <div className="row">
                                            <div className="col-6">
                                                <button
                                                    onClick={() => {
                                                        this.props.toggleForm();
                                                    }}
                                                    type="button"
                                                    className="btn btn-default btn-xl text-uppercase btn-block"
                                                >
                                                    Back to Search
                                                </button>
                                            </div>
                                            {this.props.isHighSchool && this.props.showMemberInfo ? (
                                                <div className="col-6">
                                                    <button
                                                        disabled={this.props.submitting}
                                                        type="submit"
                                                        className="btn btn-primary btn-xl text-uppercase btn-block"
                                                    >
                                                        Invite Player
                                                    </button>
                                                </div>
                                            ) : (
                                                <div className="col-6">
                                                    <button
                                                        disabled={this.props.submitting}
                                                        type="submit"
                                                        className="btn btn-primary btn-xl text-uppercase btn-block"
                                                    >
                                                        Add Member
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    );
                }}
            </Form>
        );
    }
}

export default ClubAddMembersForm;
